<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="600px">
    <div style="margin: 20px 110px 0 80px">
      <el-form label-position="right" label-width="90px" :model="brand" :rules="rules" ref="brand" :key="isNew">
        <input-form-item label="品牌代码" prop="code"></input-form-item>
        <input-form-item label="品牌名称" prop="name"></input-form-item>
        <status-form-item label="状态"></status-form-item>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import InputFormItem from '@/components/form/InputFormItem'
  import StatusFormItem from '@/components/form/StatusFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'

  export default {
    name: 'EditBrandDialog',
    components: {
      TextareaFormItem,
      StatusFormItem,
      InputFormItem
    },
    props: {
      brand: {
        type: Object,
        required: true
      },
      readOnly: Boolean
    },
    data () {
      return {
        rules: {
          name: [
            {
              required: true,
              message: '请输入品牌名称',
              trigger: 'blur'
            }
          ],
          code: [
            {
              required: true,
              message: '请输入品牌代码',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      closed () {
        if (!this.readOnly) {
          this.$refs.brand.resetFields()
        }
      },
      add () {
        this.$refs.brand.validate(valid => {
          if (!valid) return

          this.$store.dispatch('brand/add', this.$_.cloneDeep(this.brand)).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.brand.validate(valid => {
          if (!valid) return

          this.$store.dispatch('brand/updateOne', this.$_.cloneDeep(this.brand)).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.brand.id
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增品牌'
        return this.readOnly ? '查看品牌' : '编辑品牌'
      }
    }
  }
</script>
